// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qonMo3 {
  width: 100%;
  max-width: calc(
    var(--current-grid-columns, 4) * 80px + var(--current-grid-gutter, 16px) * (var(--current-grid-columns, 4) - 1)
  );
  min-height: 400px;
  padding: var(--spacing-3, 24px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-3, 24px);
}

/* Mobile (320px ~ 599px) */
@media (max-width: 599px) {
  .qonMo3 {
    max-width: 100%;
    min-height: auto;
    padding: var(--spacing-2, 16px);
  }
}

/* Tablet (600px ~ 1023px) */
@media (min-width: 600px) and (max-width: 1023px) {
  .qonMo3 {
    max-width: 380px;
  }
}

/* Desktop (1024px+) */
@media (min-width: 1024px) {
  .qonMo3 {
    max-width: 440px;
  }
}

.P6RhJU {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
}
.Gu3WV2 {
  font-size: var(--type-title-md-font-size);
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-regular);
  margin-bottom: 20px;
}
.LTe97s {
  display: flex;
  flex-direction: column;
}
.txwOqS {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}
.IIfgGm {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--surface-primary-medium);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.IIfgGm img {
  width: 20px;
  height: 20px;
  display: block;
}
.NcvcWz {
  display: flex;
  justify-content: flex-start;
}
.qkplfL {
  color: var(--link-default);
  font-size: var(--font-size-sm);
  text-decoration: underline;
  font-weight: var(--font-weight-regular);
}
.uu_Qig {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: var(--spacing-2, 16px);
  gap: 4px;
}
.luLNc6 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  vertical-align: middle;
}
.fq7o7I {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: var(--text-primary-medium);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
}
.fq7o7I:hover {
  color: var(--text-primary-bright);
  text-decoration: underline;
}
.fq7o7I:active {
  color: var(--text-primary-strong);
}
.k08t7P {
  width: 100%;
  max-width: 100%;
  border-top: var(--login-card-wrapper-border, 4px);
  border-radius: 0 0 var(--radius-s, 8px) var(--radius-s, 8px);
  background: var(--background-white);
  box-shadow: var(--card-box-shadow);
  padding: var(--spacing-4, 32px) var(--spacing-3, 24px);
}

/* Mobile: padding (320px ~ 599px) */
@media (max-width: 599px) {
  .k08t7P {
    padding: var(--spacing-3, 24px) var(--spacing-2, 16px);
    border-top: none;
    border-radius: var(--radius-s, 8px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX;;GAEC;EACD,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,+BAA+B;EACjC;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,QAAQ;AACV;AACA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,eAAe;EACf,iDAAiD;EACjD,4DAA4D;EAC5D,mCAAmC;EACnC,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA,oCAAoC;AACpC;EACE;IACE,sDAAsD;IACtD,gBAAgB;IAChB,mCAAmC;EACrC;AACF","sourcesContent":[".clientLoginContentWrapper {\n  width: 100%;\n  max-width: calc(\n    var(--current-grid-columns, 4) * 80px + var(--current-grid-gutter, 16px) * (var(--current-grid-columns, 4) - 1)\n  );\n  min-height: 400px;\n  padding: var(--spacing-3, 24px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-3, 24px);\n}\n\n/* Mobile (320px ~ 599px) */\n@media (max-width: 599px) {\n  .clientLoginContentWrapper {\n    max-width: 100%;\n    min-height: auto;\n    padding: var(--spacing-2, 16px);\n  }\n}\n\n/* Tablet (600px ~ 1023px) */\n@media (min-width: 600px) and (max-width: 1023px) {\n  .clientLoginContentWrapper {\n    max-width: 380px;\n  }\n}\n\n/* Desktop (1024px+) */\n@media (min-width: 1024px) {\n  .clientLoginContentWrapper {\n    max-width: 440px;\n  }\n}\n\n.clientLoginForm {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n.clientLoginFormTitle {\n  font-size: var(--type-title-md-font-size);\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-regular);\n  margin-bottom: 20px;\n}\n.clientLoginField {\n  display: flex;\n  flex-direction: column;\n}\n.clientLoginInputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.clientLoginPasswordToggle {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: var(--surface-primary-medium);\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.clientLoginPasswordToggle img {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n.clientLoginForgotWrapper {\n  display: flex;\n  justify-content: flex-start;\n}\n.clientLoginForgot {\n  color: var(--link-default);\n  font-size: var(--font-size-sm);\n  text-decoration: underline;\n  font-weight: var(--font-weight-regular);\n}\n.clientLoginNoAccessWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: var(--spacing-2, 16px);\n  gap: 4px;\n}\n.clientLoginNoAccessText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  vertical-align: middle;\n}\n.clientLoginCreateAccount {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: 100%;\n  letter-spacing: 0px;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--text-primary-medium);\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  text-decoration: none;\n}\n.clientLoginCreateAccount:hover {\n  color: var(--text-primary-bright);\n  text-decoration: underline;\n}\n.clientLoginCreateAccount:active {\n  color: var(--text-primary-strong);\n}\n.clientLoginCardWrapper {\n  width: 100%;\n  max-width: 100%;\n  border-top: var(--login-card-wrapper-border, 4px);\n  border-radius: 0 0 var(--radius-s, 8px) var(--radius-s, 8px);\n  background: var(--background-white);\n  box-shadow: var(--card-box-shadow);\n  padding: var(--spacing-4, 32px) var(--spacing-3, 24px);\n}\n\n/* Mobile: padding (320px ~ 599px) */\n@media (max-width: 599px) {\n  .clientLoginCardWrapper {\n    padding: var(--spacing-3, 24px) var(--spacing-2, 16px);\n    border-top: none;\n    border-radius: var(--radius-s, 8px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clientLoginContentWrapper": `qonMo3`,
	"clientLoginForm": `P6RhJU`,
	"clientLoginFormTitle": `Gu3WV2`,
	"clientLoginField": `LTe97s`,
	"clientLoginInputWrapper": `txwOqS`,
	"clientLoginPasswordToggle": `IIfgGm`,
	"clientLoginForgotWrapper": `NcvcWz`,
	"clientLoginForgot": `qkplfL`,
	"clientLoginNoAccessWrapper": `uu_Qig`,
	"clientLoginNoAccessText": `luLNc6`,
	"clientLoginCreateAccount": `fq7o7I`,
	"clientLoginCardWrapper": `k08t7P`
};
module.exports = ___CSS_LOADER_EXPORT___;
